module.exports = __webpack_public_path__ + "img/write-no.d9990bb6.png";